
























import { defineComponent } from '@vue/composition-api';
import { AfterSignStep } from '../../../types/enums/after-sign-step';

export default defineComponent({
  setup(_props, { emit }) {
    const handleOptionPick = (option: AfterSignStep) => {
      emit('select', option);
    };

    return {
      AfterSignStep,
      handleOptionPick,
    };
  },
});
